import React from "react";
import "../css/BasicCSS.css";
import "../css/About.css";

function Basic() {
  return (
    <>
      <div class="experience" id="Experience">
        <div class="achievement">
          <div class="circle" style={{color: "#fca61f"}}>
            3rd
          </div>
          <div style={{display:"block"}} class="heading">
            <span>Studying</span>
            <span>Year</span>
          </div>
        </div>
        <div class="achievement">
          <div class="circle" style={{color: "#fca61f"}}>
            VIT
          </div>
          <div style={{display:"block"}} class="heading">
            <span>College</span>
            <span>Name</span>
          </div>
        </div>
        <div class="achievement">
          <div class="circle" style={{color: "#fca61f"}}>
            CS
          </div>
          <div style={{display:"block"}} class="heading">
            <span>Branch</span>
            <span>Name</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Basic;
